import { useRef, useEffect, useState } from 'react';
import { whyChooseUs } from '../../../mocks/home';

const WhyChooseUs = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-24 bg-cream">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div className={`transition-all duration-700 ${visible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}>
            <div className="inline-flex items-center gap-2 mb-4">
              <div className="h-0.5 w-8 bg-teal"></div>
              <span className="text-teal font-body text-xs tracking-widest uppercase font-medium">Why Choose Us</span>
            </div>
            <h2 className="font-heading font-800 text-navy text-4xl lg:text-5xl mb-6 leading-tight">
              Why Minneapolis Trusts TrueCare Moving
            </h2>
            <p className="text-charcoal/60 font-body text-lg leading-relaxed mb-8">
              We&apos;re not just movers — we&apos;re a family-owned Minneapolis team that takes genuine pride in every move we complete. From our first call to the final piece of furniture being placed, we deliver a premium moving experience at an honest price.
            </p>

            {/* Image */}
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/fbe01aa3354fc0550abbf4572ecff14b.jpg"
                alt="TrueCare Moving Services professional team"
                className="w-full h-56 object-cover object-top"
              />
            </div>
          </div>

          {/* Right - Benefits Grid */}
          <div className={`grid grid-cols-1 sm:grid-cols-2 gap-5 transition-all duration-700 delay-200 ${visible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'}`}>
            {whyChooseUs.map((item, i) => (
              <div
                key={i}
                className={`bg-white rounded-xl p-5 border border-transparent hover:border-teal/25 transition-all duration-300 group ${
                  visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                }`}
                style={{ transitionDelay: visible ? `${200 + i * 60}ms` : '0ms' }}
              >
                <div className="w-10 h-10 flex items-center justify-center bg-navy/5 group-hover:bg-teal/15 rounded-lg mb-3 transition-colors duration-300">
                  <i className={`${item.icon} text-navy group-hover:text-teal text-lg transition-colors duration-300`}></i>
                </div>
                <h4 className="font-heading font-700 text-navy text-sm mb-1.5">{item.title}</h4>
                <p className="text-charcoal/55 font-body text-xs leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
